import { useTranslation } from 'react-i18next';
import { Customer } from '../../api/CustomersAPI';
import { Employee } from '../../api/EmployeesAPI';

type Props = {
  customer: Customer;
  employees: Employee[];
  isSaving: boolean;
  onSave: (employeeId: string | undefined) => Promise<void>;
};

const CustomerTableAssigneeSelect = ({ customer, employees, isSaving, onSave }: Props) => {
  const { t } = useTranslation();
  const currentValue = customer.employeeId != null ? String(customer.employeeId) : '';

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const nextValue = event.target.value;
    if (nextValue === currentValue) {
      return;
    }
    void onSave(nextValue || undefined);
  };

  return (
    <div className="min-w-[10rem] max-w-[14rem]" onClick={(event) => event.stopPropagation()}>
      <select
        value={currentValue}
        disabled={isSaving}
        onChange={handleChange}
        aria-label={t('customers.details.assigned_to') || 'Assigned to'}
        className="w-full max-w-full rounded border border-gray-200 bg-white px-2 py-1 text-sm text-gray-700 truncate cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-400 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <option value="">{t('customers.details.unassigned')}</option>
        {employees.map((employee) => (
          <option key={employee.id} value={String(employee.id)}>
            {employee.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomerTableAssigneeSelect;
